// source: imports/content/training_platform.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.com.chegg.rio.content.TrainingPlatform', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.content.TrainingPlatform = {
  EDMINGLE: 0
};

goog.object.extend(exports, proto.com.chegg.rio.content);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/content/training_platform_pb.js
// module id = 4321
// module chunks = 11